"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionMenuContentContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
// import * as Colors from "../colors";
exports.ActionMenuContentContainer = styled_components_1.default.div `
  padding: 5px;

  li {
    padding: 10px 0;
    font-size: 16px;
  }
`;
//# sourceMappingURL=action-menu-content-container.js.map